import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link, useNavigate } from "react-router-dom";
import { getData, putData } from "../../FetchNodeServices";
import { useSelector, useDispatch } from "react-redux";
import { InfinitySpin } from "react-loader-spinner";
import { addUser } from "../../redux/userSlice";
import AlertMessages from "../Mains/Alerts";

const BasicDetails = (props) => {
  // console.log(props.state);
  const [isActivated, setActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState();
  // const { state } = props.location;
  const [isDataChanged, setDataChanged] = useState(false);
  const [userId, setUserId] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountId, setAccountId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [financialYear, setFinancialYear] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const customer = useSelector((state) => state.user.users[0]);
  const user = customer.userId;
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const [isFormValid, setIsFormValid] = useState(false);
  const [alerts, setAlerts] = useState([]);
  let navigate = useNavigate();

  useEffect(function () {
    fetchCustomerAdmins();
  }, []);

  useEffect(() => {
    setIsFormValid(!!accountName && !!customerName && !!emailId && !!financialYear && !!phoneNumber && !emailError && !phoneError);
  }, [accountName, customerName, emailId, financialYear, phoneNumber, emailError, phoneError]);

  const userRole = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userRole;
  // const getUserIdByRole = () => {
  //   switch (userRole) {
  //     case "A":
  //       return localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userId;
  //     case "U":
  //       return localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).parentAccountId;
  //     case "S":
  //       return customer.userId;
  //     default:
  //       return "";
  //   }
  // };

  const handleToggle = () => {
    setActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const fetchCustomerAdmins = async () => {
    // const user = getUserIdByRole();
    setIsLoading(true);
    let result = await getData("users/basic-details/" + user);
    if (result) {
      setUserId(result.userId);
      setAccountId(result.accountId);
      setAccountName(result.accountName);
      setCustomerName(result.customerName);
      setEmailId(result.email);
      setFinancialYear(result.financialYear);
      setPhoneNumber(result.phoneNumber);
      setIsLoading(false);
      if (userRole !== "S") {
        dispatch(addUser(result));
      }
    }
  };

  const handleFinancialYear = (event) => {
    handleInputChange(event, setFinancialYear);
  };
  const handleInputChange = (event, setter, errorSetter) => {
    const { value } = event.target;
    setter(value);
    setDataChanged(true);

    // Email validation
    if (setter === setEmailId) {
      // General email validation pattern for local part and domain
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      // Split the email into parts for custom validation
      const [localPart, domainPart] = value.split("@");

      // General email pattern validation
      if (!emailRegex.test(value)) {
        errorSetter("Invalid email address format.");
      } else if (domainPart && domainPart.split(".").length !== 2) {
        // Ensure there's exactly one dot in the domain part (no subdomains)
        errorSetter("Domain should contain only one dot after '@'.");
      } else if (domainPart && (domainPart.split(".")[1].length < 2 || domainPart.split(".")[1].length > 4)) {
        // Ensure the TLD (suffix) is between 2 to 4 characters long
        errorSetter("Domain suffix should be 2 to 4 characters long.");
      } else {
        // Clear any previous errors
        errorSetter(null);
      }
    }

    // Phone number validation
    if (setter === setPhoneNumber) {
      // Regex to allow phone numbers in the format +91-9999-2345 or similar
      const phoneRegex = /^\+?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{1,4}$/;

      // Check if the phone number matches the desired format
      if (!phoneRegex.test(value)) {
        errorSetter("Invalid phone number format.");
      } else {
        errorSetter(null); // Clear any previous errors if valid
      }

      setter(value); // Update the phone number state
    }
  };

  // const handleInputChange = (event, setter, errorSetter) => {
  //   const { value } = event.target;
  //   setter(value);
  //   setDataChanged(true);

  //   if (setter === setEmailId) {
  //     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //     if (!emailRegex.test(value)) {
  //       errorSetter("Please enter a valid email address.");
  //     } else {
  //       const [localPart, domainPart] = value.split("@");
  //       const domainParts = domainPart.split(".");

  //       if (
  //         localPart.startsWith(".") ||
  //         localPart.endsWith(".") ||
  //         domainPart.includes("..") ||
  //         domainPart.startsWith(".") ||
  //         domainPart.endsWith(".") ||
  //         domainParts.length > 2
  //       ) {
  //         errorSetter(
  //           "Email is invalid. Local part or domain should not contain consecutive periods, start, or end with a period, and domain should not contain multiple top-level domains."
  //         );
  //       } else {
  //         errorSetter(null);
  //       }
  //     }
  //   }

  //   if (setter === setPhoneNumber) {
  //     const value = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
  //     setPhoneNumber(value);
  //     const phoneRegex = /^\d{10}$/;
  //     if (!phoneRegex.test(value)) {
  //       setPhoneError("Phone number must be 10 digits.");
  //     } else {
  //       setPhoneError(null);
  //     }
  //   }
  // };

  const handleSubmit = async () => {
    if (!isDataChanged || userRole === "U") return;
    if (!isFormValid) {
      // alert("Please fill in all required fields.");
      setAlerts([{ variant: "danger", heading: "Please fill in all required fields." }]);
      return;
    }
    setIsLoading(true);
    const formData = {
      userId: userId,
      accountId: accountId,
      accountName: accountName,
      customerName: customerName,
      email: emailId,
      financialYear: financialYear,
      phoneNumber: phoneNumber,
    };
    console.log("called");
    let result = await putData("users/basic-details", formData);
    if (result) {
      // alert("User updated Successfully!");
      setAlerts([{ variant: "success", heading: "User updated Successfully!." }]);
      setDataChanged(false);
      setIsLoading(false);
      navigate("/ebilling-detail");
    } else {
      // alert("Something went wrong!");
      setAlerts([{ variant: "danger", heading: "Something went wrong!" }]);
    }
  };
  const handleClick = () => {
    navigate("/ebilling-detail");
  };
  const handleClick1 = () => {
    navigate("/ebasic-detail");
  };

  const handleClick2 = () => {
    navigate("/ebranding");
  };

  // const handleClear = () => {
  //   // setAccountName("");
  //   // setAccountId("");
  //   // setCustomerName("");
  //   // setEmailId("");
  //   // setFinancialYear("");
  //   // setPhoneNumber("");
  //   fetchCustomerAdmins();
  //   setDataChanged(false);
  // };
  // const handleClear = () => {
  //   setAccountName("");
  //   setAccountId("");
  //   setCustomerName("");
  //   setEmailId("");
  //   setFinancialYear("");
  //   setPhoneNumber("");
  //   setDataChanged(false);
  // };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className={`py-3 ${isLoading ? "blur" : ""}`}>
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <Link to="/manage-customer">
                <li>
                  <i className="bi bi-people"></i> Customer
                </li>
              </Link>
              <span className="breadcrumb_slash">/</span>
              <Link to="/manage-customer">
                <li>
                  <i className="bi bi-app-indicator mx-2"></i> Manage Customer
                </li>
              </Link>
              <span className="breadcrumb_slash">/</span>
              <li>
                <i className="bi bi-pencil-square mx-2"></i>Edit Basic Details
              </li>
            </ul>

            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>
          <div className="steps_box mb-3 fw-600">
            <div onClick={handleClick1} style={{ cursor: 'pointer' }}>
              <span className="step_count active">1</span> Edit Basic Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <div onClick={handleClick} style={{ cursor: 'pointer' }}>
              <span className="step_count">2</span> Edit Billing Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <Link to = "/ebranding"><div>
              <span className="step_count">3</span>Edit Branding
            </div>
            </Link>
          </div>
          

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Account Name</label>
                    <input
                      type="text"
                      value={accountName}
                      className="form-control"
                      placeholder="Enter account name"
                      onChange={(event) => handleInputChange(event, setAccountName)}
                      readOnly={userRole === "U"}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Account ID</label>
                    <input
                      type="text"
                      value={accountId}
                      className="form-control"
                      placeholder="Enter project location"
                      readOnly
                      onChange={(event) => handleInputChange(event, setAccountId)}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Customer Name</label>
                    <input
                      type="text"
                      value={customerName}
                      className="form-control"
                      placeholder="Enter customer name"
                      readOnly={userRole === "U"}
                      onChange={(event) => handleInputChange(event, setCustomerName)}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Email ID</label>
                    <input
                      type="email"
                      value={emailId}
                      className="form-control"
                      placeholder="Enter email-ID"
                      readOnly={userRole === "U"}
                      onChange={(event) => handleInputChange(event, setEmailId, setEmailError)}
                    />
                    {emailError && <div className="text-danger">{emailError}</div>}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Financial Year</label>
                    <select name="" value={financialYear} id="" className="form-control" onChange={handleFinancialYear} disabled={userRole === "U"}>
                      <option value={"Jan - Dec"}>Jan - Dec</option>
                      <option value={"Apr - Mar"}>Apr - Mar</option>
                    </select>
                  </div>
                </div>
                {/* <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Phone</label>
                    <input
                      type="tel"
                      value={phoneNumber}
                      className="form-control"
                      placeholder="Enter Phone"
                      pattern="[0-9]{3} [0-9]{3} [0-9]{4}"
                      maxlength="12"
                      readOnly={userRole === "U"}
                      onChange={(event) => handleInputChange(event, setPhoneNumber)}
                    />
                  </div>
                </div> */}
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="phone">Phone</label>
                    <input
                      type=""
                      value={phoneNumber}
                      className="form-control"
                      placeholder="Enter Phone"
                      pattern="[0-9]{3} [0-9]{3} [0-9]{4}"
                      maxLength="16"
                      readOnly={userRole === "U"}
                      inputMode="numeric"
                      onChange={(event) => {
                        const value = event.target.value;
                        const numericValue = value.replace(/\D/g, "");
                        setPhoneNumber(numericValue);
                        handleInputChange(event, setPhoneNumber, setPhoneError);
                      }}
                    />
                    {phoneError && <div className="text-danger">{phoneError}</div>}
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                {/* <div className="button_group">
                  <button
                    type="button"
                    className="btn bg-danger-subtle text-danger"
                    onClick={() => handleClear()}
                  >
                    Clear Values
                  </button>
                </div> */}
                <div className="button_group">
                  <button
                    type="button"
                    className="btn btn-success px-4"
                    onClick={() => {
                      if (isDataChanged) {
                        handleSubmit();
                      } else {
                        navigate("/ebilling-detail");
                      }
                    }}
                  >
                    {isDataChanged && isFormValid ? "Update" : "Next"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
